import React from 'react';

type CarouselProps = {
    defaultIndex?: number;
} & React.ComponentPropsWithRef<'div'>;

export const Carousel = React.forwardRef(({ defaultIndex = 0, children, ...props }: CarouselProps, ref: React.MutableRefObject<HTMLDivElement>) => {
    const carouselRef = ref || (React.useRef(ref) as React.MutableRefObject<HTMLDivElement>);

    React.useEffect(() => {
        if (!carouselRef.current) return;
        const childObj = carouselRef.current.children.item(defaultIndex);
        if (!childObj) return;
        carouselRef.current.scrollTo({ behavior: 'smooth', left: (childObj as HTMLDivElement).offsetLeft });
    }, [defaultIndex]);

    return (
        <div className={'flos-carousel'} ref={carouselRef} {...props}>
            {children}
        </div>
    );
});

Carousel.displayName = 'Carousel';

export type { CarouselProps };
export default Carousel;
